import styled from "styled-components";

export const StyledLine = styled.div`
    background-color: #ebebeb;
    height: 1px;
    width: 93%;
    margin: 15px 0;

    @media(min-width: 890px){
        width: 56%;
    }
`